import {ps_order_return,
    add_order_return,
    update_order_return,
    delete_order_return} from "../../api/ps_orders_return.api"

const state = {
    ps_orders_return: []
}

const mutations = {

    set_ps_order_return(state, ps_orders_return) {
        state.ps_orders_return = ps_orders_return
    },

    add_ps_order_return(state, order_return) {
        state.ps_orders_return = [ ...state.ps_orders_return,order_return]
    },

    delete_ps_order_return(state, order_return) {
        state.ps_orders_return = state.ps_orders_return.filter(function( obj )
        {
            return obj.id !== order_return.id;
        })
    },
    update_ps_order_return(state, order_return) {
        state.ps_orders_return = [
            ...state.ps_orders_return.filter(element => element.id !== order_return.id),
            order_return
        ]
    },

}

const actions = {
    order_return_all({state, commit}) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            ps_order_return()
                .then((response) => {
                    if (response.status == '200') {
                        commit('set_ps_order_return',response.data)
                        resolve(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        )
    },
    order_return_add({state, commit}, order_return) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            add_order_return(order_return)
                .then((response) => {
                    if (response.status == '200') {
                        resolve(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        )
    },
    order_return_update({state, commit}, order_return) {

        // On met à jour la base
        return new Promise((resolve, reject) =>
            update_order_return(order_return)
                .then((response) => {
                    if (response.status == '200') {
                        this._vm.$message({
                            message: 'Update Retour OK',
                            type: 'success',center: true
                        });
                        resolve(response);
                    }
                })
                .catch(error => {
                    this._vm.$message({
                        message: 'Update Retour KO',
                        type: 'error',center: true
                    });
                    reject(error);
                })
        )
    },
    order_return_delete({state, commit}, order_return) {

        return new Promise((resolve, reject) =>
            delete_order_return(order_return)
                .then((response) => {
                    if (response.status == '200') {

                        this._vm.$message({
                            message: 'Suppression retour OK',
                            type: 'success',
                            center: true
                        });
                        resolve(response);

                    }
                })
                .catch(error => {
                    this._vm.$message({
                        message: 'Suppression retour KO',
                        type: 'success',
                        center: true
                    });
                    reject(error);
                })
        )
    }
}

const getters = {

}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}